
import { IAskusQuestion } from '@/models/askus.model';
import { IAttributeValue } from '@/models/attribute.model';
import { PropType } from 'vue';
export default {
  name: 'AskusAttributeBadges',
  props: {
    question: {
      required: true,
      type: Object as PropType<IAskusQuestion>,
    },
    attributes: {
      required: true,
      type: Array as PropType<IAttributeValue[]>,
    },
  },
  setup() {
    function getAttributeValueById(question: IAskusQuestion, attributeid: number) {
      const attr = question.attributes.find((x: IAttributeValue) => x.id == attributeid);
      if (attr == null || attr == undefined) {
        return '';
      }
      return attr.value_human;
    }
    return {
      getAttributeValueById,
    };
  },
};
